import React, { useState } from 'react';
import { TYPE_CHARACTERS } from './TypeCharacters';
import { TYPE_CARD } from '../data/types';
import './PlayingCard.css';

export default function PlayingCard({ typeCode, size = 'large', flipped = false, onClick }) {
  const [hovered, setHovered] = useState(false);
  const card = TYPE_CARD[typeCode];
  const Character = TYPE_CHARACTERS[typeCode];
  if (!card || !Character) return null;

  const isRed    = card.suit === '♥' || card.suit === '♦';
  const suitColor = isRed ? '#DC2626' : '#111827';

  const dims     = { large: [160, 224], medium: [116, 162], small: [80, 112] };
  const charSize = { large: 96, medium: 70, small: 46 };
  const [w, h]   = dims[size] || dims.large;

  return (
    <div
      className={`playing-card playing-card--${size}${hovered ? ' hovered' : ''}${flipped ? ' flipped' : ''}`}
      style={{ width: w, height: h }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={onClick}
    >
      <div className="card-inner">
        {/* FRONT */}
        <div className="card-front">
          {/* Top-left */}
          <div className="card-corner card-corner--tl" style={{ color: suitColor }}>
            <div className="card-rank">{card.rank}</div>
            <div className="card-suit-sm">{card.suit}</div>
          </div>

          {/* Top-right type code */}
          <div className="card-code" style={{ color: suitColor }}>{typeCode}</div>

          {/* Character illustration */}
          <div className="card-character-wrap">
            <Character size={charSize[size]} />
          </div>

          {/* Bottom-left (inverted) */}
          <div className="card-corner card-corner--br" style={{ color: suitColor }}>
            <div className="card-suit-sm">{card.suit}</div>
            <div className="card-rank">{card.rank}</div>
          </div>
        </div>

        {/* BACK */}
        <div className="card-back">
          <div className="card-back-inner">
            <div className="card-back-border">
              <div className="card-back-logo">ICHTYP.DE</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
